class VideoPlayerUtil {
  /**
   * @type {import('Common/Service/Analytics/types').IAnalyticsService}
   */
  #analyticsService

  get states () {
    return {
      // using youtube states as the default. Other players will be translated
      unstarted: -1,
      ended: 0,
      playing: 1,
      paused: 2,
      buffering: 3,
      queued: 5
    }
  }

  getStateString (state) {
    return Object.keys(this.states).find((key) => this.states[key] === state)
  }

  /**
   * @param {import('Common/Service/Analytics/types').IAnalyticsService} analyticsService
   */
  setAnalyticsService (analyticsService) {
    this.#analyticsService = analyticsService
  }

  // eslint-disable-next-line no-unused-vars
  trackHeartbeat (player, streamType, tournamentId, streamId) {
    // if (this.#analyticsService) {
    //   this.#analyticsService.track(AnalyticsEventTypes.Heartbeat, {
    //     player: player,
    //     streamType: streamType,
    //     tournamentId: tournamentId,
    //     streamId: streamId
    //   })
    // }
  }
}

export default new VideoPlayerUtil()
